module.exports = __webpack_public_path__ + "img/118D-14.250.f6bb97c1.png";